import React from 'react'

const Thanks=({business_name})=>{
    setTimeout(() => {
        // window.history.back();
        document.referrer?window.location = document.referrer + '?received=true':window.history.back()

       
       
      }, 6000);
    return(<div>
<h1>
Thanks!<br />
Thank you for the payment, you will be immediately transferred back to {business_name}, website

</h1>
    </div>)
}

export default Thanks


// WEBPACK FOOTER //
// ./src/components/Thanks.js